import { useCallback } from 'react';

import { useBetSubmissionComplete } from '@/feature/betslip-sbk/components/betslip-action-tray/hooks/use-bet-submission-complete';
import { useIsSweepsOrPredictionsProduct } from '@/hooks/use-is-sweeps-or-predictions-product';
import { useSubscribeAuth } from '@/utils/websocket/hooks';
import { BetGroupUpdateMessage } from '@/utils/websocket/types';

import { useSbkBetSlipStore } from '../use-sbk-betslip-store';

export const useSubscribeBetGroupUpdate = () => {
    const updateSubmittedBetStatus = useSbkBetSlipStore(state => state.actions.updateSubmittedBetStatus);
    const enabled = useIsSweepsOrPredictionsProduct();

    const onComplete = useBetSubmissionComplete();

    const handler = useCallback(
        (message: BetGroupUpdateMessage) => {
            updateSubmittedBetStatus(
                message.betProducerId,
                message.status,
                message.betGroupId,
                message.rejectionReason,
                onComplete,
                message.position
            );
        },
        [updateSubmittedBetStatus, onComplete]
    );

    useSubscribeAuth<'betGroupUpdate'>('bet_group_update', handler, enabled);
};
